'use strict';

var React = require('react'),
    PinIt = require('../atoms/PinIt'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    ShareActionCreators = require('../actions/ShareActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ServiceTypes = require('../constants/ServiceTypes'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    { PropTypes } = React;

require('./PinterestImage.less');

var PinterestImage = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    stampId: PropTypes.number.isRequired,
    image: PropTypes.object.isRequired
  },

  render() {
    var thumbnailUrl = getThumbnailUrl(this.props.image, {
      width: 256,
      height: 256,
      mode: 'preview'
    });

    return (
      <a className='PinterestImage'
         onClick={this.handleImageClick}>

        <img src={thumbnailUrl} />

        <div className='PinterestImage-button'>
          <PinIt />
        </div>
      </a>
    );
  },

  handleImageClick() {
    ShareActionCreators.shareStamp({
      stampId: this.props.stampId,
      service: ServiceTypes.PINTEREST,
      imageUrl: this.props.image.url,
      source: AnalyticsSources.PINTEREST_PICKER
    });
  }
});

module.exports = PinterestImage;



/** WEBPACK FOOTER **
 ** ./molecules/PinterestImage.jsx
 **/